/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react'

import { ChecklistsListMetadata } from '../../../assets/ts/data/checklists-metadata'
import Accordions from '../../../components/accordions/accordions'
import ChecklistList from '../../../components/checklist-list/checklist-list'
import useChecklistsMetadataLookup from '../../../hooks/use-checklist-metadata-lookup'
import useChecklistsMetadata from '../../../hooks/use-checklists-metadata'
import useCommonMetadata from '../../../hooks/use-common-metadata'
import { MetadataContext } from '../../../store/metadata-context-provider'
import './checklist.css'

interface ChecklistProps {
  category: string | undefined
  subCategory: string | undefined
}
const Checklist = (props: ChecklistProps) => {

  const { 
    categories, 
    checklistsMetadata,
    checklistsMetadataLookup,
    subcategories
  } = useContext(MetadataContext)
  const [filterCheckListItems, setFilterChecklistItems] =
    useState<ChecklistsListMetadata[]>([])
  useEffect(() => {
    getCheckListItems()
  }, [
    props?.category
  ])
  const getCheckListItems = () => {
    let CheckListFilter
    if (props?.subCategory === '' || !props?.subCategory)
      CheckListFilter = categories?.filter(
        (item) => item?.Category === props?.category
      )
    else
      CheckListFilter = subcategories?.filter(
        (item) =>
          item?.SubCategory === props?.subCategory
      )
    const CheckListLookupFilter = checklistsMetadataLookup?.filter(
      (data) => data?.CommonMetadata_Code === CheckListFilter[0]?.Value
    )
    const checkListItems: any = []
    CheckListLookupFilter.forEach((i) => {
      const checkListItem = checklistsMetadata?.filter(
        (item) => item?.Code === i?.CheckListMetadata_Code
      )
      checkListItems.push(checkListItem[0])
    })
    setFilterChecklistItems(checkListItems)
  }
  
  const rightAccordionItems = [
    {
      Id: 1,
      content: <ChecklistList checklistMetaData={filterCheckListItems} />,
      extras: (
        <span className='icon-Checklisticon color-primary font-15'></span>
      ),
      is_active: 'false',
      title: 'Checklist',
    },
  ]
  return (
    <div className='shadow card w-100 p-relative mb-3'>
      <div className='checklistinfo'>
        <Accordions
          accordionitemclass=''
          className='accordions overflow-hidden'
          count='badge bgcolor-primary border-radius3 px-2 py-1 font-12 whitetext poppins-semibold ms-1'
          defaultActivekey='1'
          icon='icon-arrow-down font-15 ms-auto bold pe-1'
          inputProps={{
            className:
              'card-header border-bottom1 gap-2 flex-wrap d-flex align-items-center',
            contentclassName: 'py-0',
          }}
          items={rightAccordionItems}
        />
      </div>
    </div>
  )
}
export default Checklist
